/**
 * Helper function to make authenticated API calls
 * Automatically includes the auth token from localStorage
 */

import { API_BASE_URL } from '../config';

export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  // Add auth header if token exists
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  // Handle 401 - redirect to login
  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  return response;
};

// Convenience methods
export const apiGet = (endpoint) => fetchWithAuth(endpoint);

export const apiPost = (endpoint, data) => 
  fetchWithAuth(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const apiPut = (endpoint, data) =>
  fetchWithAuth(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

export const apiDelete = (endpoint) =>
  fetchWithAuth(endpoint, {
    method: 'DELETE',
  });
